import { useSelector } from 'react-redux';
import { useParams, useLocation, matchPath, generatePath } from 'react-router-dom';
import { apAppOriginSelector, payAppOriginSelector } from '@/domain/env';
import ROUTES_PATH from '@/router/routesPathConfig';

const useRedirectBetweenApps = () => {
  const { companyId } = useParams();
  const location = useLocation();
  const path = location.pathname;
  const payAppOrigin = useSelector(payAppOriginSelector);
  const apAppOrigin = useSelector(apAppOriginSelector);
  const getRedirectUrl = () => {
    // from AP to PAY
    if (
      matchPath(
        {
          path: ROUTES_PATH.COMPANY_WORKSPACE.absolute,
        },
        path,
      ) ||
      matchPath(
        {
          path: ROUTES_PATH.COMPANY_CONFIDENTIAL_WORKSPACE.absolute,
        },
        path,
      )
    ) {
      return generatePath(ROUTES_PATH.PAY_COMPANY.absolute, { companyId });
    }

    if (
      matchPath(
        {
          path: ROUTES_PATH.DOCUMENT.absolute,
        },
        path,
      )
    ) {
      return generatePath(ROUTES_PATH.PAY_COMPANY.absolute, { companyId });
    }

    if (
      matchPath(
        {
          path: ROUTES_PATH.COMPANY_SETTINGS.absolute,
        },
        path,
      )
    ) {
      return generatePath(ROUTES_PATH.PAY_COMPANY_SETTINGS_PROVIDERS.absolute, { companyId });
    }

    // from PAY to AP
    if (
      matchPath(
        {
          path: ROUTES_PATH.PAY_COMPANY.absolute,
          end: false,
        },
        path,
      )
    ) {
      return generatePath(ROUTES_PATH.COMPANY_WORKSPACE_CATEGORY_UNDEFINED.absolute, { companyId });
    }

    if (
      matchPath(
        {
          path: ROUTES_PATH.PAY_PAYMENT.absolute,
        },
        path,
      )
    ) {
      return generatePath(ROUTES_PATH.COMPANY_WORKSPACE_CATEGORY_UNDEFINED.absolute, { companyId });
    }

    if (
      matchPath(
        {
          path: ROUTES_PATH.PAY_COMPANY_SETTINGS.absolute,
        },
        path,
      )
    ) {
      return generatePath(ROUTES_PATH.COMPANY_SETTINGS_GENERAL_MAIN.absolute, { companyId });
    }

    return null;
  };

  const isPayModule = path.startsWith('/pay/');

  const redirectBetweenApps = () => {
    const newPath = getRedirectUrl();
    if (!newPath) return;

    const targetOrigin = isPayModule ? apAppOrigin : payAppOrigin;

    window.open(targetOrigin ? `${targetOrigin}${newPath}` : newPath, '_blank', 'noopener,noreferrer');
  };

  return { redirectBetweenApps, isPayModule };
};

export default useRedirectBetweenApps;
